if (!customElements.get('hs-logo-carousel')) {
  class HsLogoCarousel extends HTMLElement {
    constructor() {
      super();

      this.initSlider = this.initSlider.bind(this);
      this.destroySlider = this.destroySlider.bind(this);
      this.handleMouseEnter = this.handleMouseEnter.bind(this);
      this.handleMouseLeave = this.handleMouseLeave.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.handleSectionLoad = this.handleSectionLoad.bind(this);
    }

    connectedCallback() {
      this.initSlider();

      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        document.addEventListener('shopify:section:load', this.handleSectionLoad);
      }
    }

    disconnectedCallback() {
      this.destroySlider();

      if (window.Shopify && window.Shopify.designMode) {
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        document.removeEventListener('shopify:section:load', this.handleSectionLoad);
      }
    }

    initSlider() {
      const slider = this.querySelector('.hs-logo-carousel__slider');

      if (!slider) {
        return;
      }

      const $slider = $(slider);

      if ($slider.hasClass('slick-initialized')) {
        return;
      }

      const prevArrow = this.querySelector('.hs-logo-carousel__arrow--prev');
      const nextArrow = this.querySelector('.hs-logo-carousel__arrow--next');
      const dotsContainer = this.querySelector('.hs-logo-carousel__dots');

      const mode = this.dataset.mode || 'infinite';
      const isInfiniteMode = mode === 'infinite';

      const baseConfig = {
        slidesToShow: 7,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        pauseOnHover: true,
        pauseOnFocus: true,
        variableWidth: false,
        draggable: true,
        swipe: true,
        touchMove: true
      };

      const modeConfig = isInfiniteMode ? {
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,
        cssEase: 'linear',
        dots: false
      } : {
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 800,
        cssEase: 'ease',
        dots: true,
        appendDots: dotsContainer,
        dotsClass: 'slick-dots'
      };

      const responsiveConfig = isInfiniteMode ? [
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 6,
            speed: 5000
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
            speed: 4500
          }
        },
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 4,
            speed: 4000,
            arrows: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            speed: 3500,
            arrows: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            speed: 3000,
            arrows: false
          }
        }
      ] : [
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 6
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5
          }
        },
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 4,
            arrows: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            arrows: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            arrows: false
          }
        }
      ];

      const slickConfig = {
        ...baseConfig,
        ...modeConfig,
        responsive: responsiveConfig
      };

      $slider.slick(slickConfig);

      $slider.on('mouseenter', this.handleMouseEnter);

      $slider.on('mouseleave', this.handleMouseLeave);

      this.$slider = $slider;
    }

    destroySlider() {
      if (this.$slider && this.$slider.hasClass('slick-initialized')) {
        this.$slider.off('mouseenter', this.handleMouseEnter);
        this.$slider.off('mouseleave', this.handleMouseLeave);
        this.$slider.slick('unslick');
        this.$slider = null;
      }
    }

    handleMouseEnter() {
      if (this.$slider) {
        this.$slider.slick('slickPause');
      }
    }

    handleMouseLeave() {
      if (this.$slider) {
        this.$slider.slick('slickPlay');
      }
    }

    handleBlockSelect(event) {
      if (this.contains(event.target) && this.$slider) {
        this.$slider.slick('slickPause');
      }
    }

    handleSectionLoad(event) {
      if (this.contains(event.target)) {
        this.destroySlider();
        setTimeout(() => {
          this.initSlider();
        }, 100);
      }
    }
  }

  customElements.define('hs-logo-carousel', HsLogoCarousel);
}
